module.exports = __webpack_public_path__ + "assets/img/item1@2x.4decc974.png";